import { RowNode } from 'ag-grid-community';

export type SortComparatorFn<T> = (
  prev: T,
  next: T,
  nodeA?: any,
  nodeB?: any
) => number;

export interface OrderModel {
  colId: string;
  sort: string;
}

export interface ComparatorMap {
  colId: string;
  comparator: SortComparatorFn<any>;
}

export interface SortModel extends OrderModel {
  comparator: SortComparatorFn<any>;
}

export interface SortRowNode extends RowNode {
  sortDir: boolean;
}

export function sortGrid(data: any[], sortModel: SortModel[]): any[] {
  if (!(sortModel && sortModel.length)) {
    return [...data];
  }
  return [...data].sort((prev, next) => {
    for (let k = 0; k < sortModel.length; k++) {
      const column = sortModel[k];
      const sortDirection = column.sort === 'asc' ? 1 : -1;
      const comparisonResult = column.comparator(
        prev[column.colId],
        next[column.colId],
        { data: prev, sortDir: sortDirection === 1 ? false : true },
        { data: next }
      );

      if (comparisonResult === 0) {
        continue;
      } else if (comparisonResult > 0) {
        return sortDirection;
      } else {
        return sortDirection * -1;
      }
    }
    return 0;
  });
}
